import { Button } from "@/components";
import { Close } from "@/icons";
import * as Dialog from "@radix-ui/react-dialog";
import clsx from "clsx";

type HeaderNavigationProps = {
  className?: string;
  title: string;
  closeButton: string;
  onCloseClick?: () => void;
};
export const HeaderNavigation = ({
  className = "",
  title,
  closeButton,
  onCloseClick,
}: HeaderNavigationProps) => {
  return (
    <div
      className={clsx(
        className,
        "base-row justify-content-between align-items-center",
      )}
    >
      <Dialog.Title className="fs-3 text-slate-20 fw-bold">
        {title}
      </Dialog.Title>
      <Button
        size="4"
        textColor="primary"
        bg="transparent"
        aria-label="Chiudi modale"
        onClick={onCloseClick}
        className="bmClose"
      >
        {closeButton}
        <Close className="ml-x8" />
      </Button>
    </div>
  );
};
